import { render, staticRenderFns } from "./RequestDetailModal.vue?vue&type=template&id=800f43e2&lang=pug"
import script from "./RequestDetailModal.vue?vue&type=script&lang=ts"
export * from "./RequestDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports